import useViewModel from './viewModel';

const SplitBillEquality = () => {
  useViewModel();

  return null;
};

export default SplitBillEquality;
